<template>
  <div
    class="column full-width padding-body bg-white app-settings"
    style="margin: auto"
  >
    <div class="col">
      <Error
        :error="state.error"
        @on-close="clearError"
      />

      <q-card
        flat
        bordered
        class="panel bg-blue-grey-1"
      >
        <q-card-section class="pad-panel column">
          <p class="col provision q-mb-none">
            Provisionamento VonixPhone
          </p>

          <p class="col provision q-mt-md q-mb-none">
            Headset
          </p>

          <label
            for="inputPhone"
            class="col"
          >
            <span class="label">Microfone</span>
            <FieldSelect
              :list="inputPhone.list"
              v-model="inputPhone.value"
              label="inputPhone"
            />
          </label>

          <label
            for="outputPhone"
            class="col mt8"
          >
            <span class="label">Saída de áudio</span>
            <FieldSelect
              :list="outputPhone.list"
              v-model="outputPhone.value"
              label="outputPhone"
            />
          </label>

          <label
            for="additionalDevice"
            class="col mt8"
          >
            <span class="label">Campainha</span>
            <FieldSelect
              :list="outputPhone.list"
              v-model="additionalDevice.value"
              label="additionalDevice"
            />
          </label>

          <p class="col provision q-mt-md q-mb-none">
            Preferências
          </p>

          <label
            for="locationSummaryAgent"
            class="col"
          >
            <span class="label">Sumário do agente</span>
            <FieldSelect
              :list="locationSummaryAgent.list"
              v-model="locationSummaryAgent.value"
              label="locationSummaryAgent"
            />
          </label>

          <label
            for="useDND"
            class="col mt8"
            v-if="canUseDND"
          >
            <span class="label">Usar DND</span>
            <FieldSelect
              :list="useDND.list"
              v-model="useDND.value"
              label="useDND"
            />
          </label>

          <label
            class="col mt8"
            v-if="useDND.value === 'yes'"
          >
            <div class="column">
              <span
                v-if="useDND.value === 'yes' && !dndOptionsList.length"
                class="text-red self-center q-mb-xs"
              >(Por favor, marque no mínimo um canal para bloqueio)
              </span>
              <span class="label">Bloquear canais durante DND*</span>
            </div>

            <q-option-group
              v-model="dndOptionsList"
              type="checkbox"
              :options="[
                { label: 'Chamadas', value: 'VOICE' },
                { label: 'Chats', value: 'TEXT' },
                { label: 'E-mails', value: 'MAIL' }
              ]"
              color="primary"
              dense
              inline
              class="mt8"
            />
          </label>

          <label
            v-if="dndOptionsList.includes('VOICE') && useDND.value === 'yes'"
            class="col mt8"
          >
            <span class="label">Tipo de chamadas:</span>
            <FieldSelect
              :list="dndCallTypes.list"
              v-model="dndCallTypes.value"
              label="dndCallTypes"
            />
          </label>

          <label
            for="groupQuickAnswers"
            class="col mt8"
          >
            <span class="label">Agrupar respostas rápidas por categoria</span>
            <FieldSelect
              :list="groupQuickAnswers.list"
              v-model="groupQuickAnswers.value"
              label="groupQuickAnswers"
            />
          </label>

          <label
            for="windowToForeground"
            class="col mt8"
          >
            <span class="label">Mostrar VonixPhone ao receber atendimento automático</span>
            <FieldSelect
              :list="windowToForeground.list"
              v-model="windowToForeground.value"
              label="windowToForeground"
            />
          </label>

          <label
            for="notificationStyle"
            class="col mt8"
          >
            <span class="label">Notificação da agenda</span>
            <FieldSelect
              :list="notificationStyle.list"
              v-model="notificationStyle.value"
              label="notificationStyle"
            />
          </label>

          <label
            for="notificationStyle"
            class="col mt8"
            v-if="!isAdmin"
          >
            <span class="label">Cochicho para atendimento automático</span>
            <FieldSelect
              :list="autoPlayback.list"
              v-model="autoPlayback.value"
              label="autoPlayback"
            />
          </label>

          <q-item
            v-if="autoPlayback.value === 'yes'"
            class="q-px-none q-py-none"
          >
            <q-item-section
              avatar
              class="q-pr-sm"
            >
              <q-icon
                name="mdi-volume-high"
                size="sm"
                color="grey-7"
              />
            </q-item-section>

            <q-item-section>
              <q-slider
                v-model="autoAlertVolume.value"
                :min="0"
                label
                track-color="primary"
                inner-track-color="grey-6"
                :inner-min="autoAlertVolume.min"
                :max="autoAlertVolume.max"
                :step="autoAlertVolume.step"
                color="primary"
              />
            </q-item-section>
          </q-item>

          <div
            v-if="autoPlayback.value === 'yes'"
            class="row justify-end q-pr-sm"
          >
            <q-btn
              flat
              dense
              label="Testar"
              class="q-px-sm"
              icon="mdi-bell-ring-outline"
              @click="testAutoAlert"
            />
          </div>

          <label
            for="installer"
            class="col mt8 text-right"
            v-if="binaryVersion"
          >
            <span class="label">Instalador: <b>{{ binaryVersion }}</b></span>
          </label>

          <div class="col q-mt-xl">
            <div class="row items-center">
              <div class="col">
                <q-btn
                  flat
                  dense
                  label="Cancelar"
                  color="primary"
                  v-if="!showWelcomeMessage && sipConnected"
                  @click="onCancel"
                />
              </div>

              <div
                class="col text-center appVersion"
              >
                VP: {{ version }}
              </div>

              <div class="col text-right">
                <q-btn
                  :loading="loading"
                  :disable="disableSave"
                  dense
                  label="Salvar"
                  class="q-px-md"
                  color="primary"
                  @click="onSaveSettings"
                />
              </div>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Error from '@/components/Error'
import FieldSelect from '@/components/FieldSelect'
import { getVersion } from '@/libs/version'

export default {
  components: {
    Error,
    FieldSelect
  },

  data () {
    const version = getVersion()
    const state = this.$store.state.settingsModule
    const showWelcomeMessage = !state?.customer

    return {
      version,
      showWelcomeMessage,

      loading: false,

      inputPhone: {
        value: null,
        list: []
      },

      outputPhone: {
        value: null,
        list: []
      },

      additionalDevice: {
        value: state.additionalDevice ?? 'default'
      },

      locationSummaryAgent: {
        value: state.locationSummaryAgent ?? 'topo',
        list: [{
          id: 'topo',
          label: 'Topo'
        }, {
          id: 'rodape',
          label: 'Rodapé'
        }]
      },

      useDND: {
        value: state.useDND ?? 'no',
        list: [{
          id: 'no',
          label: 'Não'
        }, {
          id: 'yes',
          label: 'Sim'
        }]
      },

      dndOptionsList: this.defaultDndOptions(state),
      dndCallTypes: {
        value: state.dndCallTypes ?? 'ALL',
        list: [{
          id: 'IN',
          label: 'Receptivas'
        }, {
          id: 'AUTO',
          label: 'Automáticas'
        }, {
          id: 'ALL',
          label: 'Receptivas e automáticas'
        }]
      },

      groupQuickAnswers: {
        value: state.groupQuickAnswers ?? 'yes',

        list: [{
          id: 'no',
          label: 'Não'
        }, {
          id: 'yes',
          label: 'Sim'
        }]
      },

      windowToForeground: {
        value: state.windowToForeground ?? 'no',

        list: [{
          id: 'no',
          label: 'Não'
        }, {
          id: 'yes',
          label: 'Sim'
        }]
      },

      notificationStyle: {
        value: state.notificationStyle ?? 'popup',

        list: [
          {
            id: 'popup',
            label: 'Pop-up'
          }, {
            id: 'sound',
            label: 'Som'
          },
          {
            id: 'soundAndPopup',
            label: 'Som e Pop-up'
          }
        ]
      },

      autoPlayback: {
        value: state.autoPlayback ?? 'yes',

        list: [{
          id: 'no',
          label: 'Não'
        }, {
          id: 'yes',
          label: 'Sim'
        }]
      },

      autoAlertVolume: {
        value: state.autoAlertVolume ?? 100,
        min: 30,
        max: 100,
        step: 5
      }
    }
  },

  mounted () {
    const vm = this

    vm.getDevices().then(() => {
      const state = vm.$store.state.settingsModule
      if (vm.inputPhone.list.find(({ id }) => id === state.inputPhone)) vm.inputPhone.value = state.inputPhone
      if (vm.outputPhone.list.find(({ id }) => id === state.outputPhone)) vm.outputPhone.value = state.outputPhone
    })
  },

  computed: {
    ...mapState({
      sipConnected: ({ sipModule }) => sipModule.sipConnected,
      canUseDND: ({ agentModule }) => agentModule?.provision?.canUseDND ?? false,

      state: ({ settingsModule, agentModule }) => {
        const agentStatus = agentModule?.session?.agent?.status
        const isLogged = Boolean(agentStatus && agentStatus !== 'OFFLINE')
        return Object.assign({}, settingsModule, { isLogged })
      }
    }),

    disableSave () {
      const vm = this

      if (!vm.useDND?.value) return true
      if (vm.dndOptionsList.length === 0 && vm.useDND.value === 'yes') return true
      if (vm.dndOptionsList.includes('VOICE') && vm.dndCallTypes.value.length === undefined) return true
      if (!vm.inputPhone?.value) return true
      if (!vm.outputPhone?.value) return true
      if (!vm.additionalDevice?.value) return true
      if (!vm.groupQuickAnswers?.value) return true
      if (!vm.locationSummaryAgent?.value) return true
      if (!vm.windowToForeground?.value) return true
      if (!vm.notificationStyle?.value) return true
      if (!vm.autoPlayback?.value) return true

      if (!vm.sipConnected) return false

      return Boolean(
        vm.useDND.value === vm.state.useDND &&
        vm.dndOptionsList === vm.state.dndOptionsList &&
        vm.dndCallTypes === vm.state.dndCallTypes &&
        vm.inputPhone.value === vm.state.inputPhone &&
        vm.outputPhone.value === vm.state.outputPhone &&
        vm.additionalDevice.value === vm.state.additionalDevice &&
        vm.groupQuickAnswers.value === vm.state.groupQuickAnswers &&
        vm.locationSummaryAgent.value === vm.state.locationSummaryAgent &&
        vm.windowToForeground.value === vm.state.windowToForeground &&
        vm.notificationStyle.value === vm.state.notificationStyle &&
        vm.autoPlayback.value === vm.state.autoPlayback &&
        vm.autoAlertVolume.value === vm.state.autoAlertVolume
      )
    }
  },

  methods: {

    defaultDndOptions (state) {
      const stateDndList = state?.dndOptionsList
      if (!stateDndList || !stateDndList.length) return ['TEXT', 'VOICE', 'MAIL']
      return stateDndList
    },
    ...mapActions({
      clearError: 'settingsModule/clearError',
      saveSettings: 'settingsModule/saveSettings',
      setAutoRejection: 'agentModule/setAutoRejection',
      playBeepAlert: 'sipModule/playBeepAlert'
    }),

    testAutoAlert () {
      this.playBeepAlert(this.autoAlertVolume.value)
    },

    onSaveSettings () {
      const vm = this
      vm.loading = true

      if (vm.useDND.value !== 'yes') this.setAutoRejection(false)

      vm.saveSettings({
        config: {
          useDND: vm.useDND.value,
          dndOptionsList: vm.dndOptionsList,
          dndCallTypes: vm.dndCallTypes.value,
          inputPhone: vm.inputPhone.value,
          outputPhone: vm.outputPhone.value,
          additionalDevice: vm.additionalDevice.value,
          groupQuickAnswers: vm.groupQuickAnswers.value,
          locationSummaryAgent: vm.locationSummaryAgent.value,
          windowToForeground: vm.windowToForeground.value,
          notificationStyle: vm.notificationStyle.value,
          autoPlayback: vm.autoPlayback.value,
          autoAlertVolume: vm.autoAlertVolume.value

        }
      })
    },

    onCancel () {
      this.$router.go(-1)
    },

    async getDevices () {
      await navigator.mediaDevices.getUserMedia({ audio: true })
      const devices = await navigator.mediaDevices.enumerateDevices()
      this.inputPhone.list = devices?.length ? this.formatDeviceList(devices, 'audioinput') : []
      this.outputPhone.list = devices?.length ? this.formatDeviceList(devices, 'audiooutput') : []
    },

    formatDeviceList: (devices, deviceTye) => (
      devices
        .filter(({ kind }) => kind === deviceTye)
        .map(({ label, deviceId: id }) => ({ id, label }))
    )
  },

  watch: {
    state ({ loading }) {
      if (loading !== this.loading) this.loading = loading
    }
  }
}

</script>

<style lang="sass" scoped>
  @import '@/styles/quasar.variables.scss'

  .app-settings
    .uppercase
      text-transform: uppercase

    .center-text
      display: block
      width: fit-content
      margin: 0 auto

    .welcome
      font-weight: bold
      font-size: 32px

    .instructions
      font-weight: normal
      font-size: 22px

    .pad-panel
      padding: 25px 32px

    .mt8
      display: block
      margin-top: 8px

    .mt20
      display: block
      margin-top: 20px

    .panel
      width: 100%
      max-width: 508px
      margin: 16px auto 0

    .provision
      font-weight: 500
      font-size: 18px

    .label
      font-weight: normal
      font-size: 14px

    .padding-body
      padding: 16px 32px
      height: 100%

    .copy
      cursor: pointer
      font-size: 10px
      float: right
      color: $primary

    .appVersion
      font-weight: normal
      font-size: 12px
      line-height: 14px
      color: #757575

    .q-field__control
      height: 36px
      min-height: 36px
      padding: 0 4px 0 8px

      .q-field__control-container
        font-style: normal
        font-weight: normal
        font-size: 13px
        line-height: 18px
        color: rgba(38,50,56, 0.9)

      &:hover
        &:before
          border: 1px solid #486e8e
          transition: none

      &:after
        border-width: 1px !important

    .q-field__control-container
      .q-field__native
        min-height: 0px !important
        padding-bottom: 5px

      .q-field__prefix
        line-height: inherit !important
        margin-bottom: 1px
        padding: 1px 1px 0 0

    .q-field__marginal
      height: 36px
      padding-bottom: 0px
</style>
